import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import SingleWirePage, { getDefaultUI } from "components/pages/SingleWirePage";

export default function CaptureSingleWirePayeeDD(props) {
  const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["payeeSelectIsActive", "isActive"], true)
    .submit();

  return (
    <SingleWirePage ui={ui} />
  )
}
